import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'shared/_ui';
import {
  loadCheckoutTelegramSdk,
  openCheckoutWithTelegram,
} from 'shared/lib/telegramCheckout';
import styles from './styles.module.scss';

export const ExternalCheckoutLink: React.FC<{ url: string }> = ({ url }) => {
  const { t } = useTranslation();
  const linkRef = React.useRef<HTMLAnchorElement>(null);

  React.useEffect(() => {
    linkRef.current?.focus();
    // The native HTTPS link remains usable even if Telegram's SDK is blocked.
    void loadCheckoutTelegramSdk().catch(() => undefined);
  }, []);

  return (
    <Flex direction="column" spacing={16}>
      <Typography.Title level={1}>{t('payment.title')}</Typography.Title>
      <Typography.Text>{t('payment.openBrowserHint')}</Typography.Text>
      <a
        ref={linkRef}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.externalCheckout}
        onClick={(event) => {
          if (openCheckoutWithTelegram(url)) event.preventDefault();
        }}
      >
        {t('payment.openInBrowser')}
      </a>
      <Typography.Text type="secondary">
        {t('payment.reopenBrowserHint')}
      </Typography.Text>
    </Flex>
  );
};
